import { render } from "./ModalTableCloseConfirm.vue?vue&type=template&id=28221360"
import script from "./ModalTableCloseConfirm.vue?vue&type=script&lang=js"
export * from "./ModalTableCloseConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__